import { action, makeObservable, observable } from 'mobx';
import { Notification } from '@bringg/react-components';
import i18next from 'i18next';

import { loadAllPresetsInfo, sendPresetViewsInitiatedEvent } from '../utils/preset-views-service';

export class PresetViewsViewStore {
	allLoaded = false;

	constructor() {
		makeObservable(this, {
			allLoaded: observable,
			loadPresetsInfo: action,
			setAllLoaded: action
		});
	}

	setAllLoaded = (value: boolean) => {
		this.allLoaded = value;
	};

	loadPresetsInfo = async () => {
		if (this.allLoaded) {
			return;
		}

		try {
			await loadAllPresetsInfo();

			this.setAllLoaded(true);
			sendPresetViewsInitiatedEvent();
		} catch (error) {
			console.error(`${i18next.t('PRESET_VIEWS.FAIL_LOAD_PRESETS')}, ${error}`);
			Notification.error(i18next.t('PRESET_VIEWS.FAIL_LOAD_PRESETS'));
		}
	};
}
